<div class="become-partner-container">
    <div class="become-partner-content">
        <div class="become-partner-header">
            <app-partner-header *ngIf="sponsorOnboardingCMSData" [sponsorOnboardingCMSData]="sponsorOnboardingCMSData"></app-partner-header>
        </div>
        <div class="become-partner-account-details">
            <app-global-error *ngIf="error" [(apiError)]="errorMsg"></app-global-error>
            <app-partner-account-details *ngIf="sponsorOnboardingCMSData" [sponsorOnboardingCMSData]="sponsorOnboardingCMSData" [partnerAccDetails]="partnerAccDetails" (partnerAccountDataValueChange)="partnerAccountDataValueChange($event)"></app-partner-account-details>
        </div>
        <div class="become-partner-business-details">
            <app-partner-business-details *ngIf="sponsorOnboardingCMSData" [sponsorOnboardingCMSData]="sponsorOnboardingCMSData" [partnerBusinessDetails]="partnerBusinessDetails" (partnerBusinessDataValueChange)="partnerBusinessDataValueChange($event)"></app-partner-business-details>
        </div>
        <div class="become-partner-owner-details">
            <app-owner-details *ngIf="sponsorOnboardingCMSData" [sponsorOnboardingCMSData]="sponsorOnboardingCMSData" [partnerAccDetails]="partnerAccDetails" [ownerDetails]="ownerDetails" (ownerDataValueChange)="ownerDataValueChange($event)"></app-owner-details>
        </div>
        <div class="become-partner-legal-info">
            <app-partner-legal-info *ngIf="sponsorOnboardingCMSData" [sponsorOnboardingCMSData]="sponsorOnboardingCMSData" [legalDetalis]="legalDetalis" (legalDataValueChange)="legalDataValueChange($event)"></app-partner-legal-info>
        </div>

        <div class="button-container">
            <app-button [displayText]="getGenericLabels?.Cancel" type="default" [showBorder]="false" [height]="48" [width]="250" (clicked)="cancel()"></app-button>
            <app-button [displayText]="getGenericLabels?.Submit" [disabled]="isValid" type="secondary" [height]="48" [width]="250" (clicked)="submitDetails()"></app-button>
        </div>
    </div>
</div>
